import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SlidersIcon, TrophyIcon, LibraryIcon, UsersIcon, HeadphonesIcon } from 'lucide-react';
const features = [{
  icon: LibraryIcon,
  title: 'Story Library',
  description: 'Find stories students are interested in.',
  color: 'primary',
  isCustomIcon: false
}, {
  icon: HeadphonesIcon,
  title: 'Read & Listen',
  description: 'Students get real time feedback on their reading accuracy',
  color: 'surface',
  isCustomIcon: false
}, {
  icon: SlidersIcon,
  title: 'Assesments Tools',
  description: 'Get detailed assesments on student reading accuracy, speed, and growth.',
  color: 'warm',
  isCustomIcon: false
}, {
  icon: TrophyIcon,
  title: '24 / 7',
  description: 'Take a reading assesment whenever you have time, 24 hours a day, 7 days a week. No need to schedule with a specialist.',
  color: 'primary',
  isCustomIcon: false
}, {
  icon: BookOpenIcon,
  title: 'Phonics Skills',
  description: 'Build foundational reading skills with targeted phonics exercises and comprehension questions.',
  color: 'surface',
  isCustomIcon: false
}, {
  icon: UsersIcon,
  title: 'All Learners',
  description: 'Perfect for K-12 students at any reading level, from early readers to advanced comprehension.',
  color: 'warm',
  isCustomIcon: false
}];
const colorMap = {
  primary: 'border-m3-on-surface bg-white/50 shadow-[0_0_20px_rgba(13,112,128,0.15)]',
  surface: 'border-m3-on-surface-light bg-white/50 shadow-[0_0_20px_rgba(16,137,155,0.15)]',
  warm: 'border-m3-outline bg-white/50 shadow-[0_0_20px_rgba(69,48,15,0.15)]'
};
const iconColorMap = {
  primary: 'bg-gradient-to-br from-m3-on-surface to-m3-on-surface-light text-white',
  surface: 'bg-gradient-to-br from-m3-surface to-m3-on-surface-light text-white',
  warm: 'bg-gradient-to-br from-word-current to-word-error-light text-word-error'
};
export function Features() {
  return <div id="features" className="py-20 bg-gradient-to-b from-m3-surface-container via-m3-surface to-m3-primary relative overflow-hidden" data-id="element-36">
      {/* Pixel Grid Background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `
          linear-gradient(0deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent),
          linear-gradient(90deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent)
        `,
      backgroundSize: '40px 40px'
    }} data-id="element-37"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-38">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-39">
          <h2 className="text-5xl sm:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface to-m3-outline mb-6" style={{
          textShadow: '0 0 30px rgba(13,112,128,0.2)'
        }} data-id="element-40">
            Power-Ups & Features
          </h2>
          <p className="text-base text-m3-on-surface-variant max-w-2xl mx-auto leading-relaxed" data-id="element-41">
            Snow Day combines proven reading methods with modern technology to
            create an engaging, effective learning experience.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-42">
          {features.map((feature, index) => <motion.div key={index} className={`p-8 border-4 rounded-lg backdrop-blur-sm ${colorMap[feature.color as keyof typeof colorMap]} hover:scale-105 transition-transform duration-200`} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          boxShadow: feature.color === 'primary' ? '0 0 40px rgba(13,112,128,0.25)' : feature.color === 'surface' ? '0 0 40px rgba(16,137,155,0.25)' : '0 0 40px rgba(69,48,15,0.25)'
        }} data-id="element-43">
              <motion.div className={`w-16 h-16 rounded-lg flex items-center justify-center mb-6 ${iconColorMap[feature.color as keyof typeof iconColorMap]} overflow-hidden`} whileHover={{
            scale: [1, 1.1, 1.05, 1.1, 1],
            rotate: [0, -2, 2, -2, 0]
          }} transition={{
            duration: 0.4,
            ease: 'steps(4)'
          }} data-id="element-44">
                {feature.isCustomIcon ? <img src={feature.customIconUrl} alt={feature.title} className="w-full h-full object-cover" style={{
              imageRendering: 'pixelated'
            }} data-id="element-45" /> : <feature.icon className="w-8 h-8" style={{
              imageRendering: 'pixelated',
              strokeWidth: 3
            }} data-id="element-46" />}
              </motion.div>
              <h3 className="text-xl font-bold text-m3-outline mb-4 uppercase tracking-wide" data-id="element-47">
                {feature.title}
              </h3>
              <p className="text-sm text-m3-on-surface-variant leading-relaxed" data-id="element-48">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}